module.exports = __webpack_public_path__ + "img/20.9f5d55a0.jpg";